import { CURRENCY_FIELDS } from '../config/currency-fields';

/**
 * Normalizes a field name for comparison (lowercase, single spaces)
 */
export function normalizeFieldName(name: string): string {
  return name
    .replace(/\s+/g, ' ')
    .replace(/\n/g, ' ')
    .trim()
    .toLowerCase();
}

/**
 * Checks if a field is a currency field
 */
export function isCurrencyField(fieldName: string): boolean {
  const normalized = normalizeFieldName(fieldName);
  return CURRENCY_FIELDS.some(f => normalizeFieldName(f) === normalized);
}
